import React from 'react';
import Top from './Top';
import Base from './Base';


function Test() {
  return (
    <>
        <Base body={<Top />}/>
    </>
  );
}

export default Test;
